var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_2326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66673 8.66667H6.66673C7.03339 8.66667 7.33339 8.36667 7.33339 8V2.66667C7.33339 2.3 7.03339 2 6.66673 2H2.66673C2.30006 2 2.00006 2.3 2.00006 2.66667V8C2.00006 8.36667 2.30006 8.66667 2.66673 8.66667ZM2.66673 14H6.66673C7.03339 14 7.33339 13.7 7.33339 13.3333V10.6667C7.33339 10.3 7.03339 10 6.66673 10H2.66673C2.30006 10 2.00006 10.3 2.00006 10.6667V13.3333C2.00006 13.7 2.30006 14 2.66673 14ZM9.33339 14H13.3334C13.7001 14 14.0001 13.7 14.0001 13.3333V8C14.0001 7.63333 13.7001 7.33333 13.3334 7.33333H9.33339C8.96673 7.33333 8.66673 7.63333 8.66673 8V13.3333C8.66673 13.7 8.96673 14 9.33339 14ZM8.66673 2.66667V5.33333C8.66673 5.7 8.96673 6 9.33339 6H13.3334C13.7001 6 14.0001 5.7 14.0001 5.33333V2.66667C14.0001 2.3 13.7001 2 13.3334 2H9.33339C8.96673 2 8.66673 2.3 8.66673 2.66667Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_2326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a5acf5143d69cfabd7ffe5e9bd289313.svg";
export { ForwardRef as ReactComponent };